import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { submitMissingBrand } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import Seo from "@/components/Seo";
import { toast } from "sonner";

export default function NotIndexed() {
  const { t, locale } = useI18n();
  const [params] = useSearchParams();
  const [state, setState] = useState({ brand_name: params.get("q") || "", website: "", email: "" });
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await submitMissingBrand(state); setDone(true); toast.success("Request sent"); }
    catch { toast.error("Failed"); }
  };
  return (
    <>
      <Seo title={t.not_in_index_title} description={t.not_in_index_body} canonicalPath="/not-indexed" locale={locale} />
      <div className="bp-container py-16 max-w-2xl">
        <h1 className="font-serif text-4xl md:text-5xl mb-4">{t.not_in_index_title}</h1>
        <p className="mb-8" style={{ color: "var(--bp-text-secondary)" }}>{t.not_in_index_body} You can request its addition using the form below.</p>
        {done ? (
          <div className="p-6 bg-white border" style={{ borderColor: "var(--bp-border)" }} data-testid="miss-thanks">
            Thanks. We&apos;ll review your request.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-widest">Brand name</label>
              <Input required value={state.brand_name} onChange={(e) => setState({ ...state, brand_name: e.target.value })} data-testid="miss-name" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest">Website (optional)</label>
              <Input value={state.website} onChange={(e) => setState({ ...state, website: e.target.value })} data-testid="miss-web" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest">Your email (optional)</label>
              <Input type="email" value={state.email} onChange={(e) => setState({ ...state, email: e.target.value })} data-testid="miss-email" />
            </div>
            <Button type="submit" className="rounded-none" data-testid="miss-submit">{t.request_brand_submit}</Button>
          </form>
        )}
      </div>
    </>
  );
}
